import Vue from 'vue'
import { Cell, CellGroup } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { NavBar } from 'vant';
import { Popover } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Tab, Tabs } from 'vant';
import { Popup } from 'vant';
import { Uploader } from 'vant';
import { Switch } from 'vant';
import { Empty } from 'vant';
import { List } from 'vant';
import { Loading } from 'vant';
import { Step, Steps } from 'vant';
import { Badge } from 'vant';
import { Dialog } from 'vant';
import { Progress } from 'vant';
import { Stepper } from 'vant';
import { Circle } from 'vant';
import { CountDown } from 'vant';
import { Notify } from 'vant';
import { Lazyload } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Lazyload);
Vue.use(Notify);
Vue.use(CountDown);
Vue.use(Circle);
Vue.use(Stepper);
Vue.use(Progress);
Vue.use(Dialog);
Vue.use(Badge);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Loading);
Vue.use(List);
Vue.use(Empty);
Vue.use(Switch);
Vue.use(Uploader)
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popover);
Vue.use(NavBar);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Cell);
Vue.use(CellGroup);
